import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useMemo, useContext, useLayoutEffect } from 'react';
import { Modal } from '../../Modal/rn/Modal';
import { ButtonEvents } from '../../../types';
import { SimpleRichText } from '../../RichText/rn/SimpleRichText';
import { ConfigContext } from '../../ConfigProvider/rn/context';
var ButtonFunction;
(function (ButtonFunction) {
  ButtonFunction[ButtonFunction["ClosePopUp"] = 1] = "ClosePopUp";
  ButtonFunction[ButtonFunction["JumpUrl"] = 2] = "JumpUrl";
})(ButtonFunction || (ButtonFunction = {}));
var ButtonStyle;
(function (ButtonStyle) {
  ButtonStyle[ButtonStyle["PrimaryButton"] = 1] = "PrimaryButton";
  ButtonStyle[ButtonStyle["SecondaryButton"] = 2] = "SecondaryButton";
})(ButtonStyle || (ButtonStyle = {}));
export var PopUpAnnouncement = function PopUpAnnouncement(props) {
  var _ref = props !== null && props !== void 0 ? props : {},
    popUpAnnouncement = _ref.popUpAnnouncement,
    onClose = _ref.onClose,
    visible = _ref.visible,
    trackingData = _ref.trackingData;
  var _ref2 = popUpAnnouncement !== null && popUpAnnouncement !== void 0 ? popUpAnnouncement : {},
    message = _ref2.message,
    title = _ref2.title,
    _ref2$button_setting = _ref2.button_setting,
    button_setting = _ref2$button_setting === void 0 ? [] : _ref2$button_setting;
  var context = useContext(ConfigContext);
  var reportConfig = context.reportConfig;
  var Modules = reportConfig.Modules,
    API_CONFIG = reportConfig.API_CONFIG,
    reportModuleLoad = reportConfig.reportModuleLoad;
  var buttons = useMemo(function () {
    return button_setting === null || button_setting === void 0 ? void 0 : button_setting.map(function (v) {
      var _trackingData$trackin;
      var buttonTrackingData = _objectSpread(_objectSpread({}, trackingData), {}, {
        trackingdataBasic: _objectSpread({}, (_trackingData$trackin = trackingData === null || trackingData === void 0 ? void 0 : trackingData.trackingdataBasic) !== null && _trackingData$trackin !== void 0 ? _trackingData$trackin : {})
      });
      if (buttonTrackingData !== null && buttonTrackingData !== void 0 && buttonTrackingData.trackingdataBasic) {
        buttonTrackingData.trackingdataBasic.button_text = v.button_text;
      }
      var defaultObj = {
        text: v.button_text,
        styles: {
          textStyle: {
            color: v.button_style === ButtonStyle.PrimaryButton ? '#EE4D2D' : 'rgba(0, 0, 0, 0.87)'
          }
        },
        onClick: function onClick() {
          onClose();
        },
        trackingData: buttonTrackingData
      };
      if ((v === null || v === void 0 ? void 0 : v.button_function) === ButtonFunction.JumpUrl) {
        return _objectSpread(_objectSpread({}, defaultObj), {}, {
          action: {
            func: ButtonEvents.Redirection,
            url_info: {
              url: v.url
            },
            showUserMessage: false
          }
        });
      }
      return defaultObj;
    });
  }, [button_setting]);
  useLayoutEffect(function () {
    if (visible && popUpAnnouncement) {
      console.log('PopUpAnnouncement load');
      reportModuleLoad(Modules.Announcements, API_CONFIG.getComposedInitSession.url);
    }
  }, [visible, popUpAnnouncement]);
  return /*#__PURE__*/React.createElement(Modal, {
    active: visible,
    onClose: onClose,
    title: title,
    haveContentScrollbar: true,
    footer: {
      buttons: buttons
    }
  }, /*#__PURE__*/React.createElement(SimpleRichText, {
    className: "pop-up-announcement-content",
    classNameStyles: {
      'pop-up-announcement-content': {
        marginTop: 16,
        marginHorizontal: 20,
        marginBottom: 24
      }
    },
    content: message || ''
  }));
};